/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Label_CustomerInputs */

const vi_receipt_label_customer = /** @type {(inputs: Receipt_Label_CustomerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách hàng`)
};

/**

* @param {Receipt_Label_CustomerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_label_customer = /** @type {((inputs?: Receipt_Label_CustomerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Label_CustomerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_label_customer(inputs)
});